import { Component, Input } from '@angular/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-prestation-empty-state',
  imports: [ButtonModule],
  templateUrl: './prestation-empty-state.component.html',
})
export class PrestationEmptyStateComponent {
  @Input() title!: string;
  @Input() text?: string;
  @Input() buttonLabel!: string;
  @Input() action!: () => void;
}
